import gql from 'graphql-tag';

export const partitionCommand = gql`
  mutation partitionCommand($eventId: ID!, $deviceId: ID!, $command: String!) {
    partitionCommand(eventId: $eventId, deviceId: $deviceId, command: $command)
  }
`;

export default partitionCommand;
